import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import CustomAlert from "../components/CustomAlert";
import { initDynamicFirebase } from "../constants/initDynamicFirebase";
import getUser from "../constants/getUser";

const BirthdayScreen = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [db, setDb] = useState(null);
    const [musics, setMusics] = useState([]);
    const [selectedMusic, setSelectedMusic] = useState("");
    const [selectedVoice, setSelectedVoice] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: "", type: "error" });

    const navigate = useNavigate();

    useEffect(() => {
        const loadFirebase = async () => {
            const user = await getUser();
            if (!user?.client) {
                setAlertInfo({ show: true, message: "Nenhum bar selecionado.", type: 'error' });
                return;
            }

            const config = {
                apiKey: user.client.firebase_api_key,
                authDomain: user.client.firebase_auth_domain,
                projectId: user.client.firebase_project_id,
                storageBucket: user.client.firebase_storage_bucket,
                messagingSenderId: user.client.firebase_messaging_sender_id,
                appId: user.client.firebase_app_id,
                measurementId: user.client.measurement_id
            };

            const firebaseDb = await initDynamicFirebase(config);
            setDb(firebaseDb);
        };

        loadFirebase();
    }, []);

    useEffect(() => {
        const fetchMusics = async () => {
            if (!db) return;
            setLoading(true);
            try {
                const musicsRef = collection(db, "musicas"); // coleção de músicas
                const snapshot = await getDocs(musicsRef);
                const list = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setMusics(list);
            } catch (error) {
                console.error("Erro ao buscar músicas:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchMusics();
    }, [db]);

    const handleSubmit = async () => {
        if (!message || !selectedMusic || !selectedVoice) {
            setAlertInfo({ show: true, message: "Por favor, preencha todos os campos!", type: 'error' });
            return;
        }

        setLoading(true);

        try {
            const voiceSelected = selectedVoice === "masculina" ? "Joey" : "Salli";

            const proxyUrl = 'https://corsproxy.io/?';
            const apiUrl = 'https://ttsmp3.com/makemp3_new.php';

            const response = await fetch(proxyUrl + encodeURIComponent(apiUrl), {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams({
                    msg: message,
                    lang: voiceSelected,
                }),
            });

            const data = await response.json();

            if (data.Error === 0) {
                const audioUrl = data.URL;

                const audio = new Audio(audioUrl);
                audio.play();

                setAlertInfo({ show: true, message: "Mensagem de aniversário enviada!", type: 'success' });
                setTimeout(() => navigate("/"), 2000);
            } else {
                setAlertInfo({ show: true, message: "Erro ao gerar áudio: " + data.Text, type: 'error' });
            }
        } catch (error) {
            console.error("Erro ao gerar voz:", error);
            setAlertInfo({ show: true, message: "Erro ao gerar voz", type: 'error' });
        } finally {
            setLoading(false);
        }
    };


    const handleCloseAlert = () => setAlertInfo({ ...alertInfo, show: false });

    return (
        <div style={styles.container}>
            {alertInfo.show && <CustomAlert message={alertInfo.message} type={alertInfo.type} onclose={handleCloseAlert} />}
            <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />

            {isSidebarOpen && (
                <div style={styles.overlay} onClick={() => setIsSidebarOpen(false)} />
            )}

            <div style={styles.navbarContainer}>
                <Navbar openSidebar={() => setIsSidebarOpen(true)} title="Aniversário" />
            </div>

            {loading && (
                <div style={styles.modalBackground}>
                    <div style={styles.activityIndicatorWrapper}>
                        <p style={{ color: "#fff" }}>Carregando...</p>
                    </div>
                </div>
            )}

            <div style={styles.formContainer}>
                <h2 style={styles.title}>Mensagem de Aniversário</h2>

                <textarea
                    placeholder="Escreva a mensagem..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    style={styles.textarea}
                />

                <select
                    value={selectedMusic}
                    onChange={(e) => setSelectedMusic(e.target.value)}
                    style={styles.select}
                >
                    <option value="">Selecione uma música</option>
                    {musics.map(music => (
                        <option key={music.id} value={music.id}>
                            {music.title}
                        </option>
                    ))}
                </select>

                <select
                    value={selectedVoice}
                    onChange={(e) => setSelectedVoice(e.target.value)}
                    style={styles.select}
                >
                    <option value="">Selecione uma voz</option>
                    <option value="masculina">Masculina</option>
                    <option value="feminina">Feminina</option>
                    <option value="crianca">Criança</option>
                </select>

                <button onClick={handleSubmit} style={styles.submitButton}>
                    Enviar Mensagem
                </button>
            </div>
        </div>
    );
};

// 🔧 Estilos
const styles = {
    container: {
        flex: 1,
        backgroundColor: "#fff",
        paddingBottom: "30px",
    },
    overlay: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 5,
    },
    formContainer: {
        marginTop: "80px",
        padding: "20px",
    },
    modalBackground: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    },
    activityIndicatorWrapper: {
        backgroundColor: "#000",
        padding: "20px",
        borderRadius: "10px",
        textAlign: "center",
    },
    navbarContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
    },
    title: {
        textAlign: "center",
        marginBottom: "20px",
    },
    textarea: {
        width: "100%",
        height: "100px",
        padding: "10px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        marginBottom: "20px",
    },
    select: {
        width: "100%",
        padding: "10px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        marginBottom: "20px",
    },
    submitButton: {
        backgroundColor: "#8A2BE2",
        padding: "15px",
        width: "100%",
        borderRadius: "8px",
        color: "#FFF",
        fontSize: "16px",
        fontWeight: "bold",
        border: "none",
        cursor: "pointer",
    },
};

export default BirthdayScreen;
